import h from 'hyperscript'
import { bemPrefixModifiers } from '../../_js/base/utils'

/**
 * Create a new callout element
 * @param {Object}                     [opts]
 * @param {string}                     [opts.title]     - title
 * @param {(string|Element|Element[])} opts.body        - content of the callout
 * @param {Object[]}                   [opts.actions]
 * @param {Object[]}                   [opts.footer]
 * @param {string}                     [opts.modifiers] - BEM modifiers for callout block
 */
function callout({ title, body, icon, actions, footer, modifiers = [] } = {}) {
  return h(
    'section',
    {
      className: bemPrefixModifiers('callout', modifiers, { includeBase: true })
        .concat(['animated', 'animated-fade-in-down'])
        .join(' '),
    },
    // Icon (optional)
    icon
      ? h('img.callout__icon', {
          src: `/images/icons/universal/color/64x64/${icon}.png`,
          width: 64,
          height: 64,
          alt: '',
          srcset: `/images/icons/universal/color/64x64/${icon}.png 1x, /images/icons/universal/color/64x64/${icon}@2x.png 2x`,
        })
      : null,
    // Content
    h('div.callout__content', [
      // Title (optional)
      title ? h('p.callout__title', title) : null,
      // Body: accept HTML string or elements
      h('div.callout__body.styled-text.styled-text--secondary', typeof body === 'string' ? { innerHTML: body } : body),
    ]),
    // Actions (optional)
    actions && actions !== []
      ? h(
          'div.callout__actions',
          actions.map((action) =>
            h(
              'a',
              {
                className: `callout__action button button--${action.primary ? 'primary' : 'secondary'}`,
                href: action.href,
              },
              action.label
            )
          )
        )
      : null,
    // Footer (optional)
    footer ? h('div.callout__footer.styled-text.styled-text--secondary', footer) : null
  )
}

export default callout
